import { ArrowIcon } from "common/assets/icons/ArrowIcon";
import React from "react";
import { Link } from "react-router-dom";
import styles from "./LinkButton.module.css";

interface Props {
  to: string;
}

export const LinkButton: React.FC<React.PropsWithChildren<Props>> = ({
  to,
  children,
}) => {
  return (
    <Link to={to} className={styles.container}>
      {children}
      <ArrowIcon color="#fd6a65" className={styles.icon} />
    </Link>
  );
};
